import { useQuery } from '@tanstack/react-query';
import { useSearchParams } from 'react-router';
import { api } from '@/lib/api';

/**
 * "Whole organization" or one project, kept in ?project= so other pages can link straight to a
 * project's settings (e.g. the test builder's "Set up an AI model").
 */
export function useScope(orgId: string | null) {
  const [params, setParams] = useSearchParams();
  const projects = useQuery({ queryKey: ['projects', orgId], queryFn: () => api.projects(orgId!), enabled: !!orgId });
  const requested = params.get('project');
  const project = (requested && projects.data?.find((p) => p.id === requested)) || null;
  const setProjectId = (id: string | null) => setParams(id ? { project: id } : {}, { replace: true });
  return { projectId: project?.id ?? null, project, projects: projects.data ?? [], setProjectId };
}
